@if (isModalActive) {
  <div class="modal-header">
    <h3 class="modal-title fkm-modal-title" id="modal-title">Mina förkalkylsmallar</h3>
    <button type="button" class="btn-close" (click)="dismiss()"></button>
  </div>
}

@if (basdata) {
  <rask-page
    [pageTitle]="isModalActive ? '' : 'Mina förkalkylsmallar'"
    [actionShow]="isAllowedToAddRows()"
    [actionFn]="addMall"
    actionTitle="Ny mall"
    noPadding>
    <ng-container *ngTemplateOutlet="content"></ng-container>
    <ng-template #content>
      <rask-container-block class="mb-0">
        <div class="forkalkylsmallar-list">
          <div class="d-flex pt-3">
            <div class="ps-5">
              <label>Namn</label>
            </div>
            <div class="ms-auto pe-5">
              <label>Senast ändrad</label>
            </div>
          </div>
          @for (mall of mallar; track mall; let i = $index) {
            <rask-toggle-panel [label]="mall.namn" class="mb-0" [defaultExpanded]="isMallDefaultExpanded(mall)">
              <ng-container header>
                <div class="col-6 me-3">{{mall.uDate | date: 'shortDate'}}@if (getDirtyStatus(i)) {
                  <span> *</span>
                }</div>
              </ng-container>
              <rask-forkalkylsmall #mallcomponents [mall]="mall" [basdata]="basdata" (refreshRequest)="refresh($event)"></rask-forkalkylsmall>
            </rask-toggle-panel>
          }
        </div>
      </rask-container-block>
    </ng-template>
  </rask-page>
}